import React, { useContext } from 'react';
import Dashboard from './components/Dashboard';
import { ConfigProvider, App as AntdApp } from 'antd';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Login } from './components/Login';
import { UserContext } from './store/user';
import { getStorageItem } from './helpers/localStorage';

const App = () => {
    const user = useContext(UserContext);
    const userEmail = getStorageItem('userEmail');

    const router = createBrowserRouter([
        {
            path: '/',
            element: user.email || userEmail ? <Dashboard /> : <Login />,
        },
    ]);

    return (
        <ConfigProvider
            theme={{
                token: {
                    colorPrimary: '#b73522',
                    colorPrimaryText: '#fef2e8',
                    colorText: '#000000',
                    colorBgLayout: '#ffffff',
                    colorBgSpotlight: '#b73522',
                    colorBorder: '#fef2e8',
                    colorPrimaryBg: '#b73522',
                    colorFillContent: '#fef2e8',
                    borderRadius: 0,
                    fontFamilyCode: '"Circular",sans-serif',
                },
            }}
        >
            <AntdApp>
            <RouterProvider router={router} />
            </AntdApp>
        </ConfigProvider>
    );
};

export default App;
